import React from "react";
import Chart from "react-apexcharts";
import CardComponent from "../../../components/CardComponent";

const GraphicalAnalysis = ({ rows, valueType }) => {
  const isEnergy = valueType === "Energy";

  const series = isEnergy
    ? [
      {
        name: "Energy Company",
        data: rows?.monthlyData?.map((item) => item?.Energy_company || 0),
      },
      {
        name: "Zones",
        data: rows?.monthlyData?.map((item) => item?.zones || 0),
      },
      {
        name: "Regional Offices",
        data: rows?.monthlyData?.map((item) => item?.regional_offices || 0),
      },
      {
        name: "Sales Areas",
        data: rows?.monthlyData?.map((item) => item?.sales_area || 0),
      },
      {
        name: "Districts",
        data: rows?.monthlyData?.map((item) => item?.districts || 0),
      },
    ]
    : [
      {
        name: "Requested",
        data:
          rows?.formattedData?.map(
            (item) => item?.[`Requested${valueType}`] || 0
          ) || [],
      },
      {
        name: "Approved",
        data:
          rows?.formattedData?.map(
            (item) => item?.[`Approved${valueType}`] || 0
          ) || [],
      },
      {
        name: "Rejected",
        data:
          rows?.formattedData?.map(
            (item) => item?.[`Rejected${valueType}`] || 0
          ) || [],
      },
    ];

  const options = {
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: isEnergy
        ? rows?.monthlyData?.map((item) => item?.month)
        : rows?.formattedData?.map((item) => item?.month),
    },
    grid: {
      borderColor: "#EFF1F3",
    },
    colors: isEnergy
      ? ["#5200ff", "#09bd94", "#f16a1b", "#00bcd4", "#f44336"]
      : ["#F39C12", "#27AE60", "#E74C3C"],
    stroke: {
      width: 2,
      curve: "smooth",
    },
  };

  return (
    <CardComponent showCardHeader={true} title="Graphical Analysis">
      <Chart options={options} series={series} type="line" height={300} />
    </CardComponent>
  );
};

export default GraphicalAnalysis;
